import React, { useState } from 'react';
import { getMaxNotificationId, notificationTitleTranslate } from '../services/notifications-helper';
import AddNotification from './add-notification';
import BusyCounterLoadingIndicator from '../../../sharedmodules/components/busyCounter/busy-counter-loading-indicator';
import CommonModal from '../../../sharedmodules/components/modal/common-modal';
import NotificationHeader from './notification-header';
import NotificationList from './notification-list';
import PropTypes from 'prop-types';

const checkNotificationFields = (notification) => notification && notification.language
    && notification.shortText && notification.title;

const Notification = ({
    auth, notifications, modal, getAdminData, busyCounter,
    updateModalVisibility, editNotificationData, addNotificationData,
    deleteNotificationItem, updateNotificationSequenceData,
}) => {

    const [isEdit, setIsEdit] = useState(false);

    const [modalTitle, setModalTitle] = useState('');
    const [editItem, setEditItem] = useState({
        shortText: '',
        title: '',
        url: '',
        id: '',
    });
    const [notificationLanguage, setNotificationLanguage] = useState('');

    React.useEffect(() => {

        getAdminData(auth.getAccessToken);

    }, [getAdminData, auth.getAccessToken]);

    const closeOpenModal = (selectedNotification) => {

        const notificationNo = getMaxNotificationId(notifications);
        const titleValue = notificationTitleTranslate(notificationNo + 1,
            selectedNotification.language);
        setEditItem({
            shortText: '',
            title: '',
            url: '',
        });
        setModalTitle(titleValue);
        setIsEdit(false);
        setNotificationLanguage(selectedNotification.language);
        updateModalVisibility(modal.isVisible);

    };

    const editNotification = (item) => {

        const titleValue = notificationTitleTranslate(item.id, item.language);

        setModalTitle(titleValue);
        setEditItem({
            shortText: item.shortText,
            title: item.title,
            url: item.url,
            id: item.id,
        });
        setIsEdit(true);
        setNotificationLanguage(item.language);
        updateModalVisibility(modal.isVisible);

    };

    const editNotificationItem = (notification) => {

        notification.language = notificationLanguage;
        notification.id = editItem.id;
        editNotificationData(auth.getAccessToken, notification, modal.isVisible);

    };

    const addNotification = (notification) => {

        notification.language = notificationLanguage;
        if (checkNotificationFields(notification)) {

            addNotificationData(auth.getAccessToken, notification, modal.isVisible);

        }

    };
    const deleteNotification = (id) => {

        deleteNotificationItem(auth.getAccessToken, id);

    };

    const updateNotificationSequence = (notificationSequence) => {

        if (notificationSequence) {

            updateNotificationSequenceData(auth.getAccessToken, notificationSequence);

        }

    };

    return (
        <main className="notifications">
            <NotificationHeader />
            <BusyCounterLoadingIndicator busyCounter={busyCounter} />
            {notifications[0].language && (
                <section className="notification-list-main">
                    <NotificationList
                        notificationList={notifications}
                        closeOpenModal={closeOpenModal}
                        editNotification={editNotification}
                        deleteNotification={deleteNotification}
                        updateNotificationSequence={updateNotificationSequence}
                    />
                </section>
            )}
            <CommonModal
                header
                footer={false}
                title={modalTitle}
                isOpen={modal.isVisible}
                onClose={() => {

                    updateModalVisibility(modal.isVisible);

                }}
                className="jd-warranty-modal modal-border"
                size="lg"
            >
                <AddNotification
                    busyCounter={busyCounter}
                    item={editItem}
                    isEdit={isEdit}
                    addNotification={addNotification}
                    editNotificationItem={editNotificationItem}
                />
            </CommonModal>
        </main>
    );

};

Notification.propTypes = {
    getAdminData: PropTypes.func.isRequired,
    busyCounter: PropTypes.bool.isRequired,
    notifications: PropTypes.array.isRequired,
    modal: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    updateModalVisibility: PropTypes.func,
    editNotificationData: PropTypes.func.isRequired,
    addNotificationData: PropTypes.func.isRequired,
    deleteNotificationItem: PropTypes.func.isRequired,
    updateNotificationSequenceData: PropTypes.func.isRequired,
};

export default Notification;
